<div class="container-close">
    <a (click)="close()" title="Fechar">
        <i class="material-icons">close</i>
    </a>
</div>
<h1>Central de Ajuda</h1>

<div class="container-text">
    <p>Precisa de Ajuda?</p>

    <p>Entre em contato através de um de nossos canais.</p>

    <p><i class="material-icons">phone</i> +55 (11) 5052-9330</p>

    <p><i class="material-icons">mail</i> suportehub@planetun.com.br</p>

    <p><i class="material-icons">mail</i> tecnologia@planetun.com.br</p>

    <p>
        <a href="http://www.grupoplanetun.com.br" target="_blank">
            <i class="material-icons">language</i> http://www.grupoplanetun.com.br/
        </a>
    </p>    
    <p>Segue links das redes sociais:</p>
</div>
<div class="container-social-media">
    <div>
        <a href="https://www.facebook.com/planetun/?locale=pt_BR" title="Facebook - Grupo Planetun" target="_blank">
            <img src="../../assets/images/facebook-logo.png" width="30px" />
        </a>
    </div>
    <div>
        <a href="https://www.instagram.com/grupoplanetun/" title="Instagram - Grupo Planetun" target="_blank">
            <img src="../../assets/images/instagram-logo.png" width="30px" />
        </a>
    </div>
    <div>
        <a href="https://br.linkedin.com/company/planetun-services"  title="LinkedIn - Grupo Planetun" target="_blank">
            <img src="../../assets/images/linkedin-logo.png" width="30px" />
        </a>
    </div>
</div>









